import produce from 'immer';

const INITIAL_STATE = {
  opened: true,
  first: null,
  second: null,
  title: null,
  loading: false,
  navigations: [],
};

export default function drawer(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@drawer/TOGGLE': {
        draft.opened = action.payload.open;
        draft.first = null;
        draft.second = null;
        break;
      }
      case '@drawer/CHANGING': {
        draft.opened = true;
        draft[action.payload.key] = action.payload.value;
        break;
      }
      case '@drawer/CLEANING_UP': {
        draft.first = null;
        draft.second = null;
        break;
      }
      case '@drawer/MODIFY_TITLE': {
        draft.title = action.payload.title;
        break;
      }
      case '@drawer/REQUEST_SUCCESS': {
        draft.loading = false;
        draft.navigations = action.payload.navigations;
        break;
      }
      case '@drawer/NAVIGATION_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@draft/REQUEST_FAILED': {
        draft.loading = false;
        break;
      }
      case '@auth/SIGN_OUT': {
        draft.navigations = [];
        draft.first = null;
        draft.second = null;
        draft.title = null;
        break;
      }
      default:
    }
  });
}
